(() => {
  const BUNDLE_CODES = ['HEXCAPS10', 'HEXCAPS20', 'HEXCAPS30'];
  let clearing = false;
  let attempts = 0;

  const normalize = (value) => String(value || '').toUpperCase().replace(/[^A-Z0-9]/g, '');

  const hasCollectorCase = (cart) =>
    (cart.items || []).some((item) => {
      const text = `${item.product_title || ''} ${item.title || ''} ${item.handle || ''} ${item.product_handle || ''}`.toLowerCase();
      return text.includes('collector case') || text.includes('case only') || text.includes('collector-case');
    });

  const discountTitles = (cart) => [
    ...(cart.cart_level_discount_applications || []).map((discount) => discount.title),
    ...(cart.discount_applications || []).map((discount) => discount.title),
    ...(cart.items || []).flatMap((item) => [
      ...(item.discounts || []).map((discount) => discount.title),
      ...(item.line_level_discount_allocations || []).map((allocation) => allocation.discount_application?.title)
    ])
  ];

  const hasBundleCode = (cart) =>
    discountTitles(cart)
      .filter(Boolean)
      .map(normalize)
      .some((title) => BUNDLE_CODES.includes(title));

  const renderSections = (sections) => {
    if (!sections) return;

    const drawerHtml = sections['cart-drawer'];
    const iconHtml = sections['cart-icon-bubble'];

    if (drawerHtml) {
      const parsedDrawer = new DOMParser()
        .parseFromString(drawerHtml, 'text/html')
        .querySelector('#CartDrawer');
      const currentDrawer = document.querySelector('#CartDrawer');
      if (parsedDrawer && currentDrawer) currentDrawer.innerHTML = parsedDrawer.innerHTML;
    }

    if (iconHtml) {
      const parsedIcon = new DOMParser()
        .parseFromString(iconHtml, 'text/html')
        .querySelector('#cart-icon-bubble');
      const currentIcon = document.querySelector('#cart-icon-bubble');
      if (parsedIcon && currentIcon) currentIcon.innerHTML = parsedIcon.innerHTML;
    }
  };

  const clearBundleCodeIfNeeded = async () => {
    if (clearing || attempts >= 3) return;
    clearing = true;

    try {
      const cartResponse = await fetch('/cart.js', {
        credentials: 'same-origin',
        cache: 'no-store'
      });
      const cart = await cartResponse.json();

      if (!hasCollectorCase(cart) || !hasBundleCode(cart)) return;

      attempts += 1;
      const sectionIds = ['cart-drawer', 'cart-icon-bubble'];
      const updateResponse = await fetch(window.routes?.cart_update_url || '/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        cache: 'no-store',
        body: JSON.stringify({
          discount: '',
          sections: sectionIds,
          sections_url: window.location.pathname
        })
      });
      const updatedCart = await updateResponse.json();
      renderSections(updatedCart.sections);
    } catch (error) {
      // Do not block cart use if Shopify refuses to clear a discount.
    } finally {
      clearing = false;
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    clearBundleCodeIfNeeded();
    [500, 1500, 3000].forEach((delay) => window.setTimeout(clearBundleCodeIfNeeded, delay));
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('cart-drawer, cart-icon-bubble, .header__icon--cart, [data-bundle-add], product-form')) {
      window.setTimeout(clearBundleCodeIfNeeded, 700);
      window.setTimeout(clearBundleCodeIfNeeded, 1800);
    }
  });
})();
